<template>
  <div>
    <graphs v-if="$user.isAdminOrCoordinator"></graphs>

    <active-jobs v-if="$user.isClientOrCarrier"></active-jobs>
  </div>
</template>

<script>
  import Graphs from './Graphs'
  import ActiveJobs from './ActiveJobs'

  export default {
    components: {
      Graphs,
      ActiveJobs
    }
  }
</script>



// WEBPACK FOOTER //
// Widgets.vue?513def0c